"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLaravelAssignment = require("cccisd-laravel-assignment");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy"));
var _list = _interopRequireDefault(require("cccisd-icons/list2"));
var _envelop = _interopRequireDefault(require("cccisd-icons/envelop5"));
var _UrlInfo = require("../../../pages/DeployTrack/UrlInfo");
var _helpers = require("../../ModalContents/helpers");
var _LoggedPawnMessages = _interopRequireDefault(require("./LoggedPawnMessages"));
var _SendMessageNow = _interopRequireDefault(require("./SendMessageNow"));
var _SurveySelector = _interopRequireDefault(require("./SurveySelector"));
var _assignment = _interopRequireDefault(require("./assignment.graphql"));
var _table = _interopRequireDefault(require("./table.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
var AppDefs = window.cccisd && window.cccisd.appDefs;
var flowDefaultValues = AppDefs.flow.defaultValueVariables;
function OutcomesData(_ref) {
  var _ref$questprojectIds = _ref.questprojectIds,
    questprojectIds = _ref$questprojectIds === void 0 ? [] : _ref$questprojectIds,
    groups = _ref.groups,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Outcomes Data' : _ref$title,
    tableQuery = _ref.tableQuery,
    messageQuery = _ref.messageQuery,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$isGroupActuallyP = _ref.isGroupActuallyPawn,
    isGroupActuallyPawn = _ref$isGroupActuallyP === void 0 ? false : _ref$isGroupActuallyP,
    _ref$tableFields = _ref.tableFields,
    tableFields = _ref$tableFields === void 0 ? [] : _ref$tableFields,
    _ref$tableColumns = _ref.tableColumns,
    tableColumns = _ref$tableColumns === void 0 ? [{
      name: 'pawn.pawnId',
      label: 'System ID',
      sort: true,
      filter: true
    }, {
      name: 'user.firstName',
      label: 'First Name',
      sort: true,
      filter: true
    }, {
      name: 'user.lastName',
      label: 'Last Name',
      sort: true,
      filter: true
    }, {
      name: 'user.username',
      label: 'Username',
      sort: true,
      filter: true
    }] : _ref$tableColumns,
    modalTitleField = _ref.modalTitleField,
    formatDefaultValues = _ref.formatDefaultValues;
  var _useParams = (0, _reactRouterDom.useParams)(),
    id = _useParams.id;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTabLoading = _useState4[0],
    setIsTabLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    assignmentList = _useState6[0],
    setAssignmentList = _useState6[1];
  var _useState7 = (0, _react.useState)(groups && (groups.find(function (group) {
      return group.groupId === Number(id);
    }) || groups[0])),
    _useState8 = _slicedToArray(_useState7, 2),
    currentGroup = _useState8[0],
    setCurrentGroup = _useState8[1];
  (0, _react.useEffect)(function () {
    getAssignmentList();
  }, [currentGroup]);
  function getAssignmentList() {
    return _getAssignmentList.apply(this, arguments);
  }
  function _getAssignmentList() {
    _getAssignmentList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            setIsLoading(true);
            _cccisdApollo.client.query({
              query: _assignment["default"],
              fetchPolicy: 'network-only',
              variables: {
                groupId: questprojectIds,
                assignmentHandle: 'outcomes_data'
              }
            }).then(/*#__PURE__*/function () {
              var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(res) {
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      _context6.n = 1;
                      return setAssignmentList(res.data.flows.assignmentList);
                    case 1:
                      setIsLoading(false);
                    case 2:
                      return _context6.a(2);
                  }
                }, _callee6);
              }));
              return function (_x6) {
                return _ref15.apply(this, arguments);
              };
            }())["catch"](function (err) {
              return console.error(err);
            });
          case 1:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return _getAssignmentList.apply(this, arguments);
  }
  var changeGroup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return setIsLoading(true);
          case 1:
            _context.n = 2;
            return setCurrentGroup(e);
          case 2:
            setIsLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function changeGroup(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var TimepointPicker = function TimepointPicker(_ref3) {
    var timepoints = _ref3.timepoints,
      currentTimepoint = _ref3.currentTimepoint,
      changeTimepoint = _ref3.changeTimepoint;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'dropdown ' + _style["default"].timepointPicker
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: 'btn btn-lg btn-primary dropdown-toggle ' + _style["default"].toggle,
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, currentTimepoint.label), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "dropdown-menu"
    }, timepoints.map(function (timepoint) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: timepoint.hash,
        className: timepoint.hash === currentTimepoint.hash ? 'active' : ''
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: 'dropdown-item pt-3 pb-3 fs-5 ' + (timepoint.handle === currentTimepoint.handle ? 'active' : ''),
        onClick: function onClick() {
          return changeTimepoint(timepoint);
        }
      }, timepoint.label));
    })));
  };
  function SurveyOptions(_ref4) {
    var surveyList = _ref4.surveyList,
      deployment = _ref4.deployment,
      currentTimepoint = _ref4.currentTimepoint;
    function _onSubmit2(_x2, _x3) {
      return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
      _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(values, closeModal) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.update', {
                deploymentId: deployment.deploymentId
              }), {
                settings: _objectSpread(_objectSpread({}, deployment.settings), {}, {
                  outcomesOptions: _objectSpread(_objectSpread({}, deployment.settings.outcomesOptions), {}, _defineProperty({}, currentGroup.groupId, values.surveys))
                }, isGroupActuallyPawn ? {
                  isOutcomesOptionsIdPawn: true
                } : {})
              }).then(function (res) {
                if (res.data.status === 'error') {
                  console.error(res.data.errors);
                  (0, _cccisdNotification["default"])({
                    message: 'There was a problem updating the survey options. Options were not saved.',
                    type: 'danger'
                  });
                } else {
                  getAssignmentList();
                  closeModal();
                  (0, _cccisdNotification["default"])('Survey options successfully updated.');
                }
              })["catch"](function (err) {
                console.error(err);
                (0, _cccisdNotification["default"])({
                  message: 'Could not update survey options. Please try again.',
                  type: 'danger'
                });
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return _onSubmit.apply(this, arguments);
    }
    function validate(values) {
      var errors = {};
      if (values.surveys.length === 0) {
        errors.surveys = 'At least one survey must be selected.';
      }
      return errors;
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      title: "Customize Surveys for ".concat(currentGroup.label, " at Timepoint ").concat(currentTimepoint.label),
      renderTrigger: function renderTrigger(_ref5) {
        var onClick = _ref5.onClick;
        return /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-lg btn-secondary",
          onClick: onClick
        }, /*#__PURE__*/_react["default"].createElement(_list["default"], {
          spaceRight: true
        }), "".concat(deployment.settings.outcomesOptions && deployment.settings.outcomesOptions[currentGroup.groupId] ? deployment.settings.outcomesOptions[currentGroup.groupId].length : deployment.settings.options.length, " Survey(s)"));
      },
      render: function render(_ref6) {
        var closeModal = _ref6.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
          validate: validate,
          onSubmit: function onSubmit(values) {
            return _onSubmit2(values, closeModal);
          },
          initialValues: {
            surveys: deployment.settings.outcomesOptions && deployment.settings.outcomesOptions[currentGroup.groupId] ? deployment.settings.outcomesOptions[currentGroup.groupId] : deployment.settings.options
          }
        }, function (_ref7) {
          var isSubmitting = _ref7.isSubmitting,
            submitForm = _ref7.submitForm;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "surveys",
            label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
              label: "Surveys",
              tooltip: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Select the survey(s) you want to present to respondents for this timepoint."))
            }),
            component: _SurveySelector["default"],
            surveyList: surveyList
          }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              justifyContent: 'flex-end'
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            className: "btn btn-primary",
            isLoading: isSubmitting,
            isDisabled: isSubmitting,
            onClick: function onClick() {
              return submitForm();
            }
          })));
        });
      }
    });
  }
  var getPreviousTimepointData = function getPreviousTimepointData(currHandle, assnID) {
    if (currHandle && tableQuery && flowDefaultValues && formatDefaultValues) {
      var assignmentNeedingPreviousSessionData = assignmentList.filter(function (assignment) {
        return assignment.settings.navigationSettings.accessPreviousSession && assignment.assignmentId === assnID;
      });
      if (assignmentNeedingPreviousSessionData.length === 1) {
        var timepointsInOrder = assignmentNeedingPreviousSessionData[0].settings.navigationSettings.timepoints;
        var currentIndex = timepointsInOrder.findIndex(function (el) {
          return el.handle === currHandle;
        });
        if (currentIndex !== 0) {
          var prevSessionDeploymentHandle = timepointsInOrder[currentIndex - 1].handle;
          return prevSessionDeploymentHandle;
        }
        return null;
      }
    }
  };
  function RenderContent(_ref8) {
    var assignment = _ref8.assignment;
    var _useState9 = (0, _react.useState)(assignment.settings.navigationSettings.timepoints[0]),
      _useState0 = _slicedToArray(_useState9, 2),
      currentTimepoint = _useState0[0],
      setCurrentTimepoint = _useState0[1];
    var _useState1 = (0, _react.useState)(assignment.deploymentList.find(function (d) {
        return d.deploymentHandle === currentTimepoint.handle;
      })),
      _useState10 = _slicedToArray(_useState1, 2),
      deployment = _useState10[0],
      setDeployment = _useState10[1];
    var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isTableLoading = _useState12[0],
      setIsTableLoading = _useState12[1];
    var _useState13 = (0, _react.useState)({
        state: {},
        table: {
          state: {
            selectedRows: [],
            data: []
          }
        }
      }),
      _useState14 = _slicedToArray(_useState13, 2),
      rtComponent = _useState14[0],
      setRtComponent = _useState14[1];
    var tableRef = (0, _react.useRef)();
    (0, _react.useEffect)(function () {
      setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
        table: tableRef.current
      }));
    }, [tableRef.current]);
    (0, _react.useEffect)(function () {
      setDeploymentInfo(deployment);
    }, []);
    var changeTimepoint = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
        var newDeployment;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return setIsTableLoading(true);
            case 1:
              newDeployment = assignment.deploymentList.find(function (d) {
                return d.deploymentHandle === e.handle;
              });
              _context3.n = 2;
              return setCurrentTimepoint(e);
            case 2:
              _context3.n = 3;
              return setDeployment(newDeployment);
            case 3:
              _context3.n = 4;
              return setDeploymentInfo(newDeployment);
            case 4:
              setIsTableLoading(false);
            case 5:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function changeTimepoint(_x4) {
        return _ref9.apply(this, arguments);
      };
    }();
    var setDeploymentInfo = /*#__PURE__*/function () {
      var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(d) {
        var _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _t = d.type;
              _context4.n = _t === 'anon' ? 1 : _t === 'known' ? 3 : _t === 'group' ? 5 : 9;
              break;
            case 1:
              _context4.n = 2;
              return setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
                state: {
                  userPath: 'pawn.',
                  pawnIdPath: '',
                  statusPath: ''
                }
              }));
            case 2:
              return _context4.a(3, 9);
            case 3:
              _context4.n = 4;
              return setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
                state: {
                  userPath: 'pawn.',
                  statusPath: 'pawn.assignmentProgress.',
                  pawnIdPath: ''
                }
              }));
            case 4:
              return _context4.a(3, 9);
            case 5:
              if (!d.settings.closedRoster) {
                _context4.n = 7;
                break;
              }
              _context4.n = 6;
              return setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
                state: {
                  userPath: 'pawn.',
                  statusPath: 'pawn.assignmentProgress.',
                  pawnIdPath: ''
                }
              }));
            case 6:
              _context4.n = 8;
              break;
            case 7:
              _context4.n = 8;
              return setRtComponent(_objectSpread(_objectSpread({}, rtComponent), {}, {
                state: {
                  pawnIdPath: 'pawn.',
                  statusPath: 'assignmentProgress.',
                  userPath: ''
                }
              }));
            case 8:
              return _context4.a(3, 9);
            case 9:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function setDeploymentInfo(_x5) {
        return _ref0.apply(this, arguments);
      };
    }();
    var columns = [].concat(_toConsumableArray(tableColumns), [{
      name: 'assignmentProgress.status',
      label: 'Status',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'selectbox',
        placeholder: '-- Choose one --',
        options: [{
          label: 'Not Started',
          value: 'Not Started'
        }, {
          label: 'In Progress',
          value: 'In Progress'
        }, {
          label: 'Complete',
          value: 'Complete'
        }]
      },
      render: function render(_ref1) {
        var value = _ref1.value;
        if (value === 'Complete') {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "badge text-bg-success"
          }, "Complete");
        }
        if (value === 'In Progress') {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "badge text-bg-warning"
          }, "In Progress");
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge text-bg-dark"
        }, "Not Started");
      }
    }, {
      name: "messageCount",
      label: 'Messages Sent',
      render: function render(_ref10) {
        var value = _ref10.value,
          row = _ref10.row;
        return /*#__PURE__*/_react["default"].createElement(_LoggedPawnMessages["default"], {
          deploymentId: deployment.deploymentId,
          pawnIdPath: "pawn.",
          row: row,
          userPath: ""
        });
      }
    },
    // TO SHOW PREVIOUS SESSION'S VALUES

    /* 1. From the Quest Design page, add `accessPreviousSession: true` to the navigation settings
    JSON for any Outcomes Data Entry players that will need to show the previous session's data.
    For example:
     "navigationSettings": {
        "respondent": "Participant",
        "roleHandle": "learner",
         "accessPreviousSession": true,
        "timepoints": [...
     2. There is a specific shape `flowProps.defaultValueVariables` needs to have in order
    to show values from the previous session as default values in the current session. In your
    app code, add:
         a) A custom function as a prop from your app's OutcomesDataEntry called `formatDefaultValues`.
        In the 3C site we just use it to give each element of `userRows` an `id` and a `label`.
         b) A custom table query that looks specifically for the previous session's data.
        See the `previousTimepointHandle` we use as a graphql variable for the <Table /> in this component.
         c) In your app's flow.json, we need a `rowPath` key with the corresponding value of the path
         to get the data from your custom table query.
     For an example, look at  3C site's <ProgressData /> and it's corresponding tableQuery.graphql.
    Also check out it's flow.json. Here's the final shape of what we send:
     <DeploymentPlayer flowProps={{
        defaultValueVariables: {
             "GroupSessionProgressIssues": {
                "userRows": [
                    {
                       "id": 0,
                       "label": "interrupts"
                   },
                   {
                       "id": 1,
                        "label": "Bullies younger classmates"
                   }
               ]
            }
        },
      }}
    />
     Note that we’ll use the array in `defaultValueVariables` from each app’s flow.json,
    typically living at storage/app/appdefs/flow.json. Here's the 3C site's
    `defaultValueVariables` from flow.json as an example:
        "defaultValueVariables": [
            {
                "handle": "GroupSessionProgressIssues",
                "label": "Progress Negative",
                "rowPath": "prevSession.GroupSessionProgressIssues.GroupSessionProgressIssues"
            },
        ]
    Each element in the flow.json array needs a `handle` and a `rowPath` */

    {
      name: 'actions',
      label: 'Actions',
      render: function render(_ref11) {
        var row = _ref11.row;
        var getPreviousDeploymentValues = function getPreviousDeploymentValues() {
          var prevSessData = flowDefaultValues.map(function (el) {
            return formatDefaultValues(row[el.rowPath], el.handle);
          });

          // `initialValues` needs to be an object
          var format = function format() {
            var obj = {};
            for (var i = 0; i < prevSessData.length; i++) {
              var results = _objectSpread({}, prevSessData[i]);
              (0, _merge2["default"])(obj, results);
            }
            return obj;
          };
          var initialValues = format();
          return initialValues;
        };
        if (assignment.settings.navigationSettings.hideRowActionsWhenComplete && row['assignmentProgress.status'] === 'Complete') {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex'
          }
        }, assignment.settings.navigationSettings.openDeploymentInNewTab ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Take Survey(s)"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          type: "button",
          className: "btn btn-primary btn-sm",
          style: {
            margin: '0 0 0 0.5rem'
          },
          href: Boilerplate.url("d/".concat(currentTimepoint.hash, "/").concat(row['pawn.respondentHash'])),
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))) : /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          title: "Surveys for ".concat(row["fields.".concat(modalTitleField)] || row['user.username'] || "System ID #".concat(row['pawn.pawnId'])),
          trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: row['assignmentProgress.status'] === 'Complete' ? "View & Edit Survey(s)" : "Take Survey(s)"
          }, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary btn-sm",
            style: {
              margin: '0 0 0 0.5rem'
            }
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
          size: "80%",
          beforeClose: function beforeClose() {
            return tableRef.current.loadData();
          },
          bodyStyle: {
            overflow: 'scroll'
          },
          render: function render(_ref12) {
            var closeModal = _ref12.closeModal;
            var assignmentOptions = deployment.settings.outcomesOptions && deployment.settings.outcomesOptions[currentGroup.groupId] ? deployment.settings.outcomesOptions[currentGroup.groupId] : deployment.settings.options;
            if (Array.isArray(assignmentOptions) && assignmentOptions.length <= 0) {
              return /*#__PURE__*/_react["default"].createElement("div", {
                className: "alert alert-warning"
              }, /*#__PURE__*/_react["default"].createElement("p", null, "There are 0 surveys selected."), /*#__PURE__*/_react["default"].createElement("button", {
                className: "btn btn-secondary",
                onClick: closeModal,
                type: "button"
              }, "Close"));
            }
            return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAssignment.DeploymentPlayer, {
              deploymentHandle: currentTimepoint.handle,
              pawnId: row['pawn.pawnId'],
              pawnHash: row['pawn.pawnHash'],
              respondentHash: row['pawn.respondentHash'],
              flowProps: _objectSpread(_objectSpread({}, currentGroup.flowProps), {}, {
                variables: _objectSpread(_objectSpread({}, currentGroup.flowProps && currentGroup.flowProps.variables), Object.entries(row).reduce(function (a, c) {
                  var key = c[0];
                  var val = c[1];
                  if (key.includes('user.')) {
                    return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, "".concat(key), val));
                  }
                  if (key.includes('fields.')) {
                    return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, "".concat(key), val));
                  }
                  return a;
                }, {})),
                defaultValueVariables: tableQuery && flowDefaultValues && formatDefaultValues ? _objectSpread({}, getPreviousDeploymentValues()) : {}
              }),
              disableLayout: true,
              enablePrintMode: true,
              assignmentOptions: assignmentOptions
            });
          }
        }), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Copy Link"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-secondary btn-sm",
          style: {
            margin: '0 0 0 0.5rem'
          },
          onClick: function onClick() {
            return (0, _UrlInfo.setClipboardText)(Boilerplate.url("d/".concat(currentTimepoint.hash, "/").concat(row['pawn.respondentHash'])));
          }
        }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null))));
      }
    }, {
      name: 'link',
      label: 'Survey Link',
      render: function render(_ref13) {
        var value = _ref13.value,
          row = _ref13.row;
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: "mailto:".concat(Boilerplate.url("d/".concat(currentTimepoint.hash, "/").concat(row['pawn.respondentHash'])))
        }, Boilerplate.url("d/".concat(currentTimepoint.hash, "/").concat(row['pawn.respondentHash'])));
      },
      hideInTable: true
    }]).filter(function (col) {
      // if isProvider is true, don't show the 'Messages Sent' column
      if (assignment.settings.navigationSettings.isProvider) {
        return col.name !== 'messageCount';
      }
      return true;
    });
    var defaultQueryVariables = {
      groupId: currentGroup.groupId,
      deploymentId: deployment.deploymentId,
      deploymentHandle: currentTimepoint.handle,
      roleHandle: assignment.settings.navigationSettings.roleHandle,
      tableFields: tableFields
    };
    var customQueryVariables = _objectSpread(_objectSpread({}, defaultQueryVariables), {}, {
      previousTimepointHandle: getPreviousTimepointData(currentTimepoint.handle, assignment.assignmentId)
    });
    return !isTabLoading && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: '2rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "btn-group",
      role: "group",
      style: {
        marginBottom: '2rem'
      }
    }, /*#__PURE__*/_react["default"].createElement(TimepointPicker, {
      timepoints: assignment.settings.navigationSettings.timepoints,
      currentTimepoint: currentTimepoint,
      changeTimepoint: changeTimepoint
    }), /*#__PURE__*/_react["default"].createElement(SurveyOptions, {
      surveyList: assignment.surveyList,
      currentTimepoint: currentTimepoint,
      deployment: deployment
    })), !assignment.settings.navigationSettings.isProvider && /*#__PURE__*/_react["default"].createElement("div", {
      role: "group",
      className: "btn-group"
    }, rtComponent && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary btn-lg"
      }, /*#__PURE__*/_react["default"].createElement(_envelop["default"], {
        spaceRight: true
      }), " Send Message"),
      title: "Send Message"
    }, /*#__PURE__*/_react["default"].createElement(_SendMessageNow["default"], {
      messageQuery: messageQuery,
      rtComponent: rtComponent,
      match: {
        params: {
          deploymentId: assignment.deploymentList.find(function (d) {
            return d.deploymentHandle === currentTimepoint.handle;
          }).deploymentId
        }
      },
      deployment: assignment.deploymentList.find(function (d) {
        return d.deploymentHandle === currentTimepoint.handle;
      }),
      groupId: currentGroup.groupId,
      roleHandle: assignment.settings.navigationSettings.roleHandle
    })))), !isTableLoading && /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
      rowKey: "pawn.pawnId",
      query: tableQuery || _table["default"],
      graphqlVariables: tableQuery && flowDefaultValues && formatDefaultValues ? customQueryVariables : defaultQueryVariables,
      columns: columns,
      ref: tableRef
    }));
  }
  if (!isLoading && groups.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, "No groups were found.", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Thinking Emoji"
    }, "\uD83E\uDD14")), /*#__PURE__*/_react["default"].createElement("p", null, "Please verify that groups have been created for this site.")));
  }
  if (!isLoading && id && !groups.find(function (group) {
    return group.groupId === Number(id);
  })) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "Invalid Group ID provided in the URL.", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Gasp Emoji"
    }, "\uD83D\uDE31")));
  }
  if (!isLoading && assignmentList && assignmentList.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '10rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "There doesn't appear to be an Outcomes Data quest configured. ", /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "Gasp Emoji"
    }, "\uD83D\uDE22")), /*#__PURE__*/_react["default"].createElement("p", null, "If this problem persists, please contact the 3C Institute support team."));
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading
  }, currentGroup && assignmentList && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("strong", null, title)), /*#__PURE__*/_react["default"].createElement("p", null, description)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-lg btn-primary dropdown-toggle",
    type: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
  }, currentGroup.label), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "dropdown-menu"
  }, groups.map(function (group) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: group.groupId
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: 'dropdown-item fs-5 ' + (group.groupId === currentGroup.groupId ? 'active' : ''),
      href: "#",
      onClick: function onClick() {
        return changeGroup(group);
      }
    }, group.label));
  }))))), /*#__PURE__*/_react["default"].createElement("br", null), !isLoading && /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: assignmentList.map(function (assignment) {
      return {
        name: assignment.settings.navigationSettings.respondent.split('').map(function (c) {
          return c === ' ' ? '%20' : c;
        }).join(''),
        title: assignment.settings.navigationSettings.respondent,
        content: /*#__PURE__*/_react["default"].createElement(RenderContent, {
          assignment: assignment
        })
      };
    }),
    onTabSelect: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return setIsTabLoading(true);
          case 1:
            setIsTabLoading(false);
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    })),
    saveInHash: true
  })));
}
var _default = exports["default"] = OutcomesData;